const keys = [
    'ONESELF_ENROLL_MY_INFO',//自己信息修改
    'ONESELF_ENROLL_TEAMMATE_INFO',//队友信息添加修改
    'ENROLL_UPDATE_PHONE',//修改手机号
    'ONESELF_ENROLL_GROUP_CANCEL',//取消组别报名
    'ONESELF_ENROLL_DOUBLE_DELETE',//双打组合删除队友
    'ONESELF_ENROLL_DELETE',//删除报名
]
let defaultState = {},
    defaultMutations = {};
for(let key of keys){
    defaultState[key] = {
        v: 0,
        value: undefined
    };
    defaultMutations[key] = (state, value)=>{
        state[key].v = new Date().getTime();
        state[key].value = value;
    };
}
const state = ()=>({
    ...defaultState
});

const mutations = {
    ...defaultMutations
}
export default {
    namespaced: true,
    state,
    mutations
}